// import { useLazyQuery } from "@apollo/client";
import { useMutation } from "@apollo/client";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Formik } from "formik";
import { messageError, messageSuccess, valiDate } from "../../helper";
import { CREATE_TYPE_DOCUMENT } from "./apollo";

export default function AddType({ newLoad, setNewLoad }) {
  const [show, setShow] = useState(false);
  const [createTypeDocument] = useMutation(CREATE_TYPE_DOCUMENT);
  const handleClose = () => setShow(false);

  return (
    <Formik
      initialValues={{
        title: "",
      }}
      enableReinitialize={true}
      validate={(values) => {
        const errors = {};
        if (!values.title) {
          errors.title = "error";
        }
        return errors;
      }}
      onSubmit={async (values) => {
        try {
          let __createTypeDocument = await createTypeDocument({
            variables: {
              data: {
                title: String(values?.title),
              },
            },
          });

          if (__createTypeDocument) {
            messageSuccess("ການດຳເນີນງານສຳເລັດ");
            setShow(false);
            setNewLoad(!newLoad);
            values.title = "";
          } else {
            messageError("ການດຳເນີນງານບໍ່ສຳເລັດ");
          }
        } catch (error) {
          messageError("ການເຂົ້າລະບົບມີຄວາມຂັດຂ້ອງ");
        }
      }}
    >
      {({ values, errors, handleChange, handleSubmit }) => (
        <React.Fragment>
          <button
            className="btn btn-primary me-2 "
            onClick={() => setShow(true)}
          >
            <i className="icon-plus-circle" /> ເພີ່ມໝວດເອກະສານ
          </button>
          <Modal
            centered
            show={show}
            onHide={() => setShow(false)}
            animation={false}
            backdrop="static"
            size="lg"
          >
            <Modal.Header closeButton>
              <Modal.Title className="fs-5">
                <i className="icon-plus" /> ເພີ່ມໝວດເອກະສານ
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="form-group">
                <label>ໝວດເອກະສານ {valiDate()}</label>
                <input
                  type="text"
                  className={
                    errors.title
                      ? "form-control form-control-lg mb-3 mt-2 is-invalid"
                      : "form-control form-control-lg mb-3 mt-2 invalid"
                  }
                  name="title"
                  value={values.title}
                  onChange={handleChange}
                  placeholder="ປ້ອນຂໍ້ມູນ..."
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                className="btn btn-primary btn-lg "
                onClick={() => handleSubmit()}
              >
                <i className="icon-check-circle me-1" />
                ບັນທຶກ
              </button>
              <button
                type="button"
                className="btn btn-light btn-lg "
                onClick={() => handleClose()}
              >
                <i className="icon-x me-2" />
                ຍົກເລີກ
              </button>
            </Modal.Footer>
          </Modal>
        </React.Fragment>
      )}
    </Formik>
  );
}
